<template>
    <button
        class="ola-btn"
        :class="buttonClasses"
        :disabled="disabled"
        v-bind="$attrs"
        @click="emit('click', $event)"
        @mouseenter="emit('mouseenter', $event)"
        @mouseleave="emit('mouseleave', $event)"
    >
        <slot></slot>
    </button>
</template>

<script setup>
import { computed } from 'vue'

// ==================== 组件选项 ====================

defineOptions({
    name: 'OlaButton'
})

// ==================== Props ====================

const props = defineProps({
    /** 按钮类型：primary, secondary, success, danger */
    type: {
        type: String,
        default: 'primary',
        validator: (value) => ['primary', 'secondary', 'success', 'danger', ''].includes(value)
    },
    /** 按钮大小：sm, lg */
    size: {
        type: String,
        default: '',
        validator: (value) => ['sm', 'lg', ''].includes(value)
    },
    /** 是否为圆角按钮 */
    round: {
        type: Boolean,
        default: false
    },
    /** 是否为线框按钮 */
    outline: {
        type: Boolean,
        default: false
    },
    /** 是否禁用 */
    disabled: {
        type: Boolean,
        default: false
    }
})

// ==================== Emits ====================

const emit = defineEmits(['click', 'mouseenter', 'mouseleave'])

// ==================== 计算属性 ====================

/** 按钮样式类 */
const buttonClasses = computed(() => [
    props.type ? `ola-btn-${props.type}` : '',
    props.size ? `ola-btn-${props.size}` : '',
    {
        'ola-btn-round': props.round,
        'ola-btn-outline': props.outline,
        'is-disabled': props.disabled
    }
])
</script>

<style>
/* 按钮样式已在全局样式文件中定义 */
/* src/assets/styles/components/_buttons.scss */
</style> 